import React, { useState, useCallback } from "react";
import "./contact.css";
import axios from "axios";
import { toast } from "react-toastify";
import Tada from "react-reveal/Tada";
import "react-toastify/dist/ReactToastify.css";
import LightSpeed from "react-reveal/LightSpeed";
import { FaLinkedin, FaFacebook, FaGithub, FaInstagram } from "react-icons/fa6";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    msg: "",
  });

  const { name, email, msg } = formData;

  // Get the email service URL from environment variable
  const emailServiceUrl = "https://email-mfm6.onrender.com";

  // Handle form field change
  const handleChange = useCallback((e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  }, []);

  // Handle submit button
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!name || !email || !msg) {
      toast.warning("Please provide all fields");
      return;
    }
    toast.warning("Please Wait, It Would take some time to send message!");
    try {
      const response = await axios.post(
        `${emailServiceUrl}/api/v1/portfolio/sendEmail`,
        { name, email, msg }
      );
      if (response.data.success) {
        toast.success(response.data.message);
        setFormData({ name: "", email: "", msg: "" });
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("An error occurred while sending the message.");
      console.error(error);
    }
  };

  return (
    <>
      <LightSpeed left>
        <div className="contact" id="contact">
          <div className="card card0 border-0">
            <div className="row">
              <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12">
                <div className="card1">
                  <div className="row border-line">
                    <img
                      src="https://img.freepik.com/premium-photo/man-touching-contact-symbols-internet-communication_220873-3864.jpg"
                      alt="contact"
                      className="images"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-6 col-lg-6 col-xl-6 col-sm-12">
                <div className="card2 d-flex card border-0 px-4 py-5">
                  <div className="row">
                    <div className="row2">
                      <a
                        href="https://www.linkedin.com/in/shivu-kumara-001598272?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app"
                        target="blank"
                        rel="noopener noreferrer"
                      >
                        <FaLinkedin
                          color="blue"
                          size={30}
                          className="ms-4 icons1"
                        />
                      </a>
                      <a
                        href="https://github.com/SHIVUKUMARA"
                        target="blank"
                        rel="noopener noreferrer"
                      >
                        <FaGithub
                          color="black"
                          size={30}
                          className="ms-4 icons1"
                        />
                      </a>
                      <a
                        href="https://www.facebook.com/shivakumara.patil.940?mibextid=ZbWKwL"
                        target="blank"
                        rel="noopener noreferrer"
                      >
                        <FaFacebook
                          color="blue"
                          size={30}
                          className="ms-4 icons1"
                        />
                      </a>
                      <a
                        href="https://www.instagram.com/shivukumara_patil/?igshid=MzMyNGUyNmU2YQ%3D%3D"
                        target="blank"
                        rel="noopener noreferrer"
                      >
                        <FaInstagram
                          color="brown"
                          size={30}
                          className="ms-4 icons1"
                        />
                      </a>
                    </div>
                    <div className="row3 px-3 mb-4 lines">
                      <div className="line" />
                      <strong className="or text-center">OR</strong>
                      <div className="line" />
                    </div>
                    <div className="row px-3">
                      <input
                        type="text"
                        name="name"
                        placeholder="Enter your Name"
                        className="mb-3"
                        value={name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="row px-3">
                      <input
                        type="text"
                        name="email"
                        placeholder="Enter your Email"
                        className="mb-3"
                        value={email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="row px-3">
                      <textarea
                        type="text"
                        name="msg"
                        placeholder="Enter your Message"
                        rows={4}
                        className="mb-3"
                        value={msg}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="row px-3">
                      <button
                        className="button"
                        type="submit"
                        onClick={handleSubmit}
                      >
                        SEND MESSAGE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LightSpeed>
      <div className="footer pb-3 ms-3">
        <Tada>
          <h4 className="text-center">Made By SHIVUKUMARA @ 2024</h4>
        </Tada>
      </div>
    </>
  );
};

export default Contact;
